import { render, staticRenderFns } from "./VentasPorPeriodo.vue?vue&type=template&id=0c8e5207&scoped=true&"
import script from "./VentasPorPeriodo.vue?vue&type=script&lang=js&"
export * from "./VentasPorPeriodo.vue?vue&type=script&lang=js&"
import style0 from "./VentasPorPeriodo.vue?vue&type=style&index=0&id=0c8e5207&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e5207",
  null
  
)

export default component.exports